import styled from "styled-components";
import Box from "../../layout/boxes/Box";
import { StyledChipProps } from "./Chip.types";

const CLASS_CHIP__ICON = ".Chip__icon";
const CLASS_CHIP__LABEL = ".Chip__label";
const CLASS_CHIP__REMOVE_BUTTON = ".Chip__remove-button";

export const StyledChip = styled(({ readOnly, ...props }: StyledChipProps) => (
	<Box {...props} />
))<StyledChipProps>`
	${CLASS_CHIP__REMOVE_BUTTON} {
		background: none;
		color: inherit;
		border: none;
		padding: 0;
	}

	${({ theme, disabled, readOnly, htmlTag }) => {
		const DEFAULT_ACCENT_COLOR = theme.palette.hexForRole("cta_default");
		const READ_ONLY_ACCENT_COLOR = theme.palette.hexForRole("fg_dark_3");
		const DISABLED_ACCENT_COLOR =
			theme.palette.hexForMandatory("primary_1_400");
		const DISABLED_BG_COLOR = theme.palette.hexForRole("cta_disabled");
		const HOVER_BG_COLOR = theme.palette.hexForRole("cta_hover");
		const HOVER_ACCENT_COLOR = theme.palette.hexForRole("fg_light_1");

		const BORDER_COLOR = disabled
			? DISABLED_ACCENT_COLOR
			: readOnly
			? READ_ONLY_ACCENT_COLOR
			: DEFAULT_ACCENT_COLOR;

		const IS_ACTIVE_BUTTON = !disabled && !readOnly && htmlTag === "button";

		return {
			backgroundColor: !disabled
				? theme.palette.hexForRole("bg_white")
				: DISABLED_BG_COLOR,
			cursor: IS_ACTIVE_BUTTON ? "pointer" : "default",
			width: "fit-content",
			border: `${theme.borderWidths.md} solid ${BORDER_COLOR}`,
			borderRadius: theme.radii.xxl,
			padding: `${theme.space.xs} ${theme.space.sm}`,
			alignItems: "center",
			display: "flex",
			transition: "background-color 200ms ease-in-out",
			[`> ${CLASS_CHIP__REMOVE_BUTTON}`]: {
				cursor: "pointer",
				svg: {
					fill: DEFAULT_ACCENT_COLOR,
				},
			},
			...(!disabled && !readOnly
				? {
						"&:hover": {
							backgroundColor: HOVER_BG_COLOR,
							[`> ${CLASS_CHIP__ICON}`]: {
								svg: {
									fill: HOVER_ACCENT_COLOR,
								},
							},
							[`> ${CLASS_CHIP__LABEL}`]: {
								color: HOVER_ACCENT_COLOR,
							},
						},
				  }
				: disabled && {
						[`> ${CLASS_CHIP__ICON}`]: {
							svg: {
								fill: DISABLED_ACCENT_COLOR,
							},
						},
						[`> ${CLASS_CHIP__LABEL}`]: {
							color: DISABLED_ACCENT_COLOR,
						},
				  }),
		};
	}};
`;
